var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0835 12.7502H10.9168V14.5835H9.0835V12.7502ZM9.0835 5.41683H10.9168V10.9168H9.0835V5.41683ZM9.991 0.833496C4.931 0.833496 0.833496 4.94016 0.833496 10.0002C0.833496 15.0602 4.931 19.1668 9.991 19.1668C15.0602 19.1668 19.1668 15.0602 19.1668 10.0002C19.1668 4.94016 15.0602 0.833496 9.991 0.833496ZM10.0002 17.3335C5.9485 17.3335 2.66683 14.0518 2.66683 10.0002C2.66683 5.9485 5.9485 2.66683 10.0002 2.66683C14.0518 2.66683 17.3335 5.9485 17.3335 10.0002C17.3335 14.0518 14.0518 17.3335 10.0002 17.3335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.8167c71680f4a5d5b6621998c064e7b7.svg";
export { ForwardRef as ReactComponent };